import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { BodegaService } from 'src/app/services/bodega.service';
import { SecurityService } from 'src/app/shared/services/security.service';


interface ICallbackInput {
  (anno: number, mes: number, bodega_codigo: number, mueveStock:boolean, additionalData: any): void
}

@Component({
  selector: 'app-modal-confirm-periodo-gestion',
  templateUrl: './modal-confirm-periodo-gestion.component.html',
  styleUrls: ['../../empresas-recibidos.component.scss'],
  providers: [SecurityService],
})
export class ModalConfirmPeriodoGestionComponent implements OnInit {

  @ViewChild('modalConfirmPeriodoGestion', { static: true }) confirmPeriodoGestionModal: ModalDirective;

  // Form
  formHeader: FormGroup;
  initialValues: any


  private rutEmpresa: number
  private sucursalCodigo: number

  optionsMonth: any[] = []
  optionsYear: any[] = []
  optionsBodega: Array<any> = [];

  // Callbacks
  private acceptCallback: ICallbackInput;
  private additionalData: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private bodegaService: BodegaService,
  ) {
    this.log = this.clog.log('MODAL-CONFIRM-PERIODO/GESTION')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadMesesAndAnhos();
    this.createFormInitialValues()
    this.createForms()
    this.loadBodegas()
  }

  loadMesesAndAnhos() {
    this.optionsMonth = this.datesService.GetMonths()
    this.optionsYear = this.datesService.GetRangeYears()
  }

  createFormInitialValues() {
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth() + 1
    this.initialValues = {
      mesPeriodo: currentMonth,
      gestion: currentYear,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      mesPeriodo: [null, [Validators.required]],
      gestion: [null, [Validators.required]],
      bodega: [null, [Validators.required]],
      GMovStock: [true, [Validators.required]]
    });

    this.setInitialValues()
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues)
    this.formHeader.get('GMovStock').setValue(true)
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  loadAndShow({ acceptCallback, additionalData }: { acceptCallback: ICallbackInput, additionalData: any }) {
    this.log('loadAndShow', additionalData)
    this.acceptCallback = acceptCallback
    this.additionalData = additionalData
    this.confirmPeriodoGestionModal.show()
  }

  accept() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const { mesPeriodo, gestion, bodega: bodega_codigo, GMovStock } = this.formHeader.value
    // const periodoGestion = new Date(gestion, mesPeriodo - 1, 1)

    if (this.acceptCallback)
      this.acceptCallback(gestion, mesPeriodo, bodega_codigo, GMovStock, this.additionalData)
    this.confirmPeriodoGestionModal.hide()
  }

}
